const openTicketLink = 'https://benepass.zendesk.com/hc/en-us/requests/new';

const simpleContactSupportMessage = 'contact our support via Menu > Contact Support';

const contactSupportMessage = `Please try again or ${simpleContactSupportMessage}`;

export { openTicketLink, contactSupportMessage, simpleContactSupportMessage };
